(function($) {

    var timeout_a;

    $(document).on( 'click', '.woocommerce-cart-form button.plus, .variations_form button.plus, .variations_form button.minus, .woocommerce-cart-form button.minus', function() {

       var qty = $( this ).parent( '.quantity' ).find( '.qty' );
       var val = parseFloat(qty.val());
       var max = parseFloat(qty.attr( 'max' ));
       var min = parseFloat(qty.attr( 'min' ));
       var step = parseFloat(qty.attr( 'step' ));

       if ( $( this ).is( '.plus' ) ) {
          if ( max && ( max <= val ) ) {
             qty.val( max );
             qty.attr('value',max);
          } else {
             qty.val( val + step );
             qty.attr('value',val + step);
          }
       } else {
          if ( min && ( min >= val ) ) {
             qty.val( min );
             qty.attr('value',min);
          } else if ( val > 1 ) {
             qty.val( val - step );
             qty.attr('value',val - step);
          }
       }

       if ( timeout_a !== undefined ) {
           clearTimeout( timeout_a );
       }

       timeout_a = setTimeout(function() {
           $("button[name='update_cart']").prop("disabled", false);
           $("button[name='update_cart']").attr("aria-disabled","false");
           $("button[name='update_cart']").trigger("click");
       }, 700 ); // 1 second delay, half a second (500) seems comfortable too

    });

    var timeout_b;


    $('body').on('wc_cart_emptied', function(){
        document.getElementById('woocommerce-cart-form').classList.add('d-none');
        location.reload();
    });


    

    $(document).on( 'change', '.woocommerce-cart-form .product-quantity .qty', function() {
        //$("button[name='update_cart']").trigger("click");
        if ( timeout_b !== undefined ) {
            clearTimeout( timeout_b );
        }

        timeout_b = setTimeout(function() {
            $("button[name='update_cart']").trigger("click");
        }, 700 ); // 1 second delay, half a second (500) seems comfortable too
    });

})
(jQuery);
